<template>
  <div>
    <div class="ssl-banner">
      <div class="inner-bound">
        <h1 class="white-color">{{ t("dns.banner.title") }}</h1>
        <p class="white-color">
          {{ t("dns.banner.desc") }}
        </p>
      </div>
      <img
        src="/static/images/banner/domain-dns-bg.png"
        alt="DNS Resolution"
        class="isPC"
      />
      <img
        src="/static/images/banner/dns-domain-name-resolution-phone.jpg"
        alt="DNS Resolution"
        class="isPhone"
      />
    </div>

    <!-- dns 产品 -->
    <section class="brand-section email-signing">
      <div class="inner-bound pt50 pb60">
        <h2 class="text-section-title" v-animate="'fadeInUp'">
          {{ t("dns.productSectionTitle") }}
        </h2>
        <div class="brand-product-grid">
          <div
            v-for="(product, index) in popularProducts"
            :key="product.code"
            :class="['brand-product-card base-card', `delay-${index}`]"
            v-animate="'fadeInUp'"
          >
            <SslProductCard :product="product" isDns />
          </div>
        </div>
      </div>
    </section>
    <!-- DNS 优势 -->
    <GridCard
      :items="plainTm('dns.dnsAdvantages.items')"
      :title="t('dns.dnsAdvantages.title')"
      isMuted
    />
 

    <div class="inner-bound pt50 ">
      <h2 v-animate="'fadeInUp'" class="text-section-title">{{ t("dns.packages.title") }}</h2>
      <table class="site-table dns-table" v-animate="'fadeInUp'">
        <thead class="site-thead dns-thead">
          <tr>
            <td colspan="2">DNS Features</td>
            <td>DNS Resolution - Free</td>
            <td class="white">DNS Resolution - Professional</td>
            <td>DNS Resolution - Business</td>
          </tr>
        </thead>
        <tbody class="site-tbody dns-tbody">
          <tr class="site-tr">
            <td rowspan="11" class="site-first">Basic Features</td>
            <td>Intelligent resolution</td>
            <td class="site-nth"><i class="dns-correct"></i></td>
            <td class="site-nth white"><i class="dns-correct"></i></td>
            <td class="site-nth"><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Global Anycast</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>IPv6 node</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Wildcard DNS</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Mixed Wildcard DNS</td>
            <td>2GB</td>
            <td class="white">5GB</td>
            <td>10GB</td>
          </tr>
          <tr>
            <td>DNSSEC</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Number of subdomains</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Domain alias</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Minimum TTL value</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>subdomain leve</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>URL forward</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr class="site-tr">
            <td rowspan="9" class="site-first">Types of DNS Record</td>
            <td>A</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>AAAA</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>CNAME</td>
            <td><i class="dns-error"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>MX</td>
            <td><i class="dns-error"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>TXT</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>URL</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>SRV</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>CAA</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>SPF</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr class="site-tr">
            <td rowspan="8" class="site-first">Other Features</td>
            <td>Quickly add resolution</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Scan existing records</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Domain remarks</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Record remarks</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>TTL default setting</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Export domain list</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Bulk management actions</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
          <tr>
            <td>Operation Log</td>
            <td><i class="dns-correct"></i></td>
            <td class="white"><i class="dns-correct"></i></td>
            <td><i class="dns-correct"></i></td>
          </tr>
        </tbody>
        <tfoot class="site-tfoot dns-tfoot">
          <tr>
            <td colspan="2"></td>
            <td>
              <a
                href="https://console.nicsrs.com/product/config/sitelock-basic"
                target="_blank"
                class="text-theme"
                >{{ t("btnText.free") }}</a
              >
            </td>
            <td class="white">
              <a
                href="https://console.nicsrs.com/product/config/sitelock-pro"
                target="_blank"
                class="text-theme"
                >{{ t("btnText.buyNow") }}</a
              >
            </td>
            <td>
              <a
                href="https://console.nicsrs.com/product/config/sitelock-business"
                target="_blank"
                class="text-theme"
                >{{ t("btnText.buyNow") }}</a
              >
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- FAQ -->
    <FAQ
      :faqItems="plainTm('cloudCodeSigning.faq.faqItems')"
      :faqTitle="t('cloudCodeSigning.faq.title')"
    />
  </div>
</template>

<script setup>
import { onMounted, nextTick, computed } from "vue";
const { t, tm, rt, locale } = useI18n();
const { plainTm } = usePlainTm();


// Get popular products
const { data: hotResp } = await useFetch("/api/product-by-code", {
  query: { code: productCodes.dns.join(",") },
  default: () => ({ status: 0, data: [] }),
});
const popularProducts = computed(() => hotResp.value?.data || []);

usePageSeo({
  title: t("dns.title"),
  description: t("dns.desc"),
  bodyId: "dns-page",
});
</script>
